/**
 * This file originated from:
 * File: app/assets/javascripts/src-zugz/shared/utils/triggerEvent.js
 * In commit: de125d9c0dbfa23a5f12f049c70f4e9e185a6932
 * For ticket: GRINS-1507
 */

const module = { name: 'Fandango/triggerEvent', exports: {} }; const exports = module.exports;

import { Fandango as Fandango } from '@grins/fd-modules/splits/require-core';

function triggerAnalyticsEvent(eventTriggered, eventData = {}) {
    const { account: { isLoggedIn, }, analyticsData: { customerGUID, deviceType, pageName: contextPageName, pageType: contextPageType, }, context: { device: { isMobile, }, }, } = Fandango;
    const { pageName = contextPageName, pageType = contextPageType, eventName, productType, productId, ...extraEventData } = eventData;
    window.dataLayer = window.dataLayer || [];
    const payload = {
        businessProperty: 'fandango',
        customerGUID,
        deviceType,
        loggedInStatus: isLoggedIn,
        platform: isMobile ? 'fandango mobile web' : 'fandango web',
        clickDetails: eventTriggered,
        ...extraEventData
    };
    if (pageName) {
        payload.pageName = pageName;
    }
    if (pageType) {
        payload.pageType = pageType;
    }
    if (eventName) {
        payload.eventName = eventName;
    }
    if (productType) {
        payload.productType = productType;
    }
    if (productId) {
        payload.productId = productId;
    }
    window.dataLayer.push(payload);
}
export default {
    triggerAnalyticsEvent
};